import { Component, Inject } from "@angular/core";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { AssessmentCentralService } from "src/app/shared/services/assessment-central.service";

@Component({
  selector: "assessment-template-create-modal",
  templateUrl: "assessment-template-create-modal.html",
  styleUrls: ["assessment-template-create-modal.scss"],
})
export class AssessmentCreateTemplateModalDialogComponent {
  categories: any;
  assessmentTags: any;
  templateForm = new FormGroup({
    name: new FormControl("", [Validators.required]),
    description: new FormControl("", [Validators.required]),
    applicability: new FormControl(""),
    assessment_scoring_scale: new FormControl(""),
    category: new FormControl("", [Validators.required]),
  });

  constructor(
    public dialogRef: MatDialogRef<AssessmentCreateTemplateModalDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private readonly assessmentCentralService: AssessmentCentralService
  ) {}

  ngOnInit() {
    this.getCategories();
  }

  getCategories() {
    this.assessmentCentralService
      .getAssessmentTemplateCategory()
      .subscribe((response) => {
        this.categories = response;
      });
  }

  getChildTags(data: any) {
    this.assessmentTags = data;
  }

  createAssessment() {
    const dialogData = this.templateForm.value;
    dialogData["selectedTags"] = this.assessmentTags;
    this.dialogRef.close(dialogData);
  }

  closeModal(): void {
    this.dialogRef.close();
  }
}
